<template>
  <div>
    <div class="row" v-if="editing">
      <div class="col-md-12">
        <div class="form-group">
          <h4 class="ts-text-sm mb-2">
            <strong>{{
              $t(
                'school.academic.operation.profile_mgt.parentProfile.currentChildren'
              )
            }}</strong>
          </h4>
          <div id="container-table">
            <table class="table table-hover ui-table">
              <thead>
                <tr>
                  <th>
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.parentProfile.no'
                      )
                    }}
                  </th>
                  <th>
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.parentProfile.name'
                      )
                    }}
                  </th>
                  <th>
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.parentProfile.sex'
                      )
                    }}
                  </th>
                  <th>
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.parentProfile.dateOfBirth'
                      )
                    }}
                  </th>
                  <th>
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.parentProfile.cardNumber'
                      )
                    }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(student, index) in edit_data.students" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>
                    {{ student.fname_foreign + '' + student.lname_foreign }}
                  </td>
                  <td>
                    {{ student.gender }}
                  </td>
                  <td>
                    {{ student.date_of_birth }}
                  </td>
                  <td>
                    {{ student.id_card_no }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <h4 class="ts-text-sm mb-2" v-if="editing">
            <strong>{{
              $t(
                'school.academic.operation.profile_mgt.parentProfile.otherChildren'
              )
            }}</strong>
          </h4>
          <div id="container-table">
            <table class="table table-hover ui-table">
              <thead>
                <tr>
                  <th style="width: 7%" class="text-center">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.parentProfile.no'
                      )
                    }}
                  </th>
                  <th>
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.parentProfile.name'
                      )
                    }}
                  </th>
                  <th style="width: 10%">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.parentProfile.sex'
                      )
                    }}
                  </th>
                  <th style="width: 12%">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.parentProfile.dateOfBirth'
                      )
                    }}
                  </th>
                  <th>
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.parentProfile.occupation'
                      )
                    }}
                  </th>
                  <th>
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.parentProfile.workPlace'
                      )
                    }}
                  </th>
                  <th style="width: 3%" class="text-center">
                    <a href="#" @click.prevent="addNew">
                      <i class="fa fa-plus"></i>
                    </a>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(child, index) in model.children_list" :key="index">
                  <td class="text-center" valign="middle">{{ index + 1 }}</td>
                  <td>
                    <input
                      type="text"
                      class="form-control only-bottom-border"
                      v-model.trim="child.child_name"
                      :class="{
                        'is-invalid': errors.has(
                          'children_list.' + index + '.child_name'
                        ),
                      }"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="
                        errors.has('children_list.' + index + '.child_name')
                      "
                    >
                      {{
                        errors.first('children_list.' + index + '.child_name')
                      }}
                    </div>
                  </td>
                  <td>
                    <select
                      class="form-control only-bottom-border"
                      v-model="child.gender"
                      :class="{
                        'is-invalid': errors.has(
                          'children_list.' + index + '.gender'
                        ),
                      }"
                    >
                      <option value>{{ $t('select') }}</option>
                      <option value="M">{{ $t('parentprofile.male') }}</option>
                      <option value="F">
                        {{ $t('parentprofile.female') }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('children_list.' + index + '.gender')"
                    >
                      {{ errors.first('children_list.' + index + '.gender') }}
                    </div>
                  </td>
                  <td>
                    <a-date-picker
                      v-model.trim="child.child_dob"
                      style="width: 100%"
                      placeholder="DD-MM-YYYY"
                      valueFormat="DD-MM-YYYY"
                      format="DD-MM-YYYY"
                      @change="onChangeDateOfBirth"
                    />
                    <!-- <ts-date-picker-input
                      v-model="child.child_dob"
                    ></ts-date-picker-input> -->
                  </td>
                  <td>
                    <input
                      type="text"
                      class="form-control only-bottom-border"
                      v-model.trim="child.child_occupation"
                      :class="{
                        'is-invalid': errors.has(
                          'children_list.' + index + '.child_occupation'
                        ),
                      }"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="
                        errors.has(
                          'children_list.' + index + '.child_occupation'
                        )
                      "
                    >
                      {{
                        errors.first(
                          'children_list.' + index + '.child_occupation'
                        )
                      }}
                    </div>
                  </td>
                  <td>
                    <input
                      type="text"
                      class="form-control only-bottom-border"
                      v-model.trim="child.work_study_place"
                      :class="{
                        'is-invalid': errors.has(
                          'children_list.' + index + '.work_study_place'
                        ),
                      }"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="
                        errors.has(
                          'children_list.' + index + '.work_study_place'
                        )
                      "
                    >
                      {{
                        errors.first(
                          'children_list.' + index + '.work_study_place'
                        )
                      }}
                    </div>
                  </td>
                  <td valign="middle">
                    <a
                      href="#"
                      class="text-danger"
                      @click.prevent="removeRow(child)"
                    >
                      <i class="fa fa-trash mt-2"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'children',
  props: ['value', 'validate', 'clear'],
  data() {
    return {
      editing: false,
      errors: new Errors(),
      model: {},
      row: {
        child_name: '',
        gender: '',
        child_dob: '',
        child_occupation: '',
        work_study_place: '',
      },
    }
  },
  created() {
    this.model = this.value
    this.setEditData()
  },
  computed: {
    ...mapState('parentProfile', ['edit_data']),
  },
  methods: {
    onChangeDateOfBirth(dateString) {
      this.child.child_dob = dateString
    },
    addNew() {
      this.model.children_list.push(_.clone(this.row))
    },
    removeRow(row) {
      this.model.children_list.splice(this.model.children_list.indexOf(row), 1)
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.student_parent_id = this.edit_data.student_parent_id
        this.model.children_list = []
        this.edit_data.children.map((el) => {
          this.model.children_list.push({
            child_name: el.child_name,
            gender: el.gender,
            child_dob: moment(el.child_dob, 'YYYY-MM-DD').format('DD-MM-YYYY'),
            child_occupation: el.child_occupation,
            work_study_place: el.work_study_place,
          })
        })
      }
    },
  },
  watch: {
    validate: {
      handler() {
        this.errors = new Errors(this.validate.errors)
      },
      deep: true,
    },
    clear: function (value) {
      if (value) {
        this.model = this.value
      }
    },
  },
}
</script>

<style lang="css" scoped>
#container-table {
  max-height: 30vh;
  height: 20vh;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
::-webkit-scrollbar {
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  background: rgb(194, 194, 194);
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
.only-bottom-border {
  border-top: none;
  border-left: none;
  border-right: none;
}
</style>
